var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompletedIcon = function SvgCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.638 1.87378L4.63796 8.87378C4.37761 9.13413 3.9555 9.13413 3.69515 8.87378L0.361816 5.54044L1.30463 4.59764L4.16655 7.45957L10.6952 0.930969L11.638 1.87378Z",
    fill: "#606060"
  })));
};
export { SvgCompletedIcon as ReactComponent };
export default __webpack_public_path__ + "assets/748f7fb8.svg";